module.exports = __webpack_public_path__ + "static/tint-no-logo-compressor-f31a995bd93a001d9e464dcebb843cdd.jpg";